import React, { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import styled from "styled-components";

import { FlexDiv } from "../Box";

import { getValuesFromDate } from "@/utils";

import "react-datepicker/dist/react-datepicker.css";

const DatePicker = ({
  value,
  onChange,
  withPortal = true,
  minDate,
  innerRef,
}) => {
  const CustomInput = forwardRef(({ onClick }, ref) => {
    const { date, month, year } = getValuesFromDate(value);

    return (
      <div ref={ref}>
        <FlexDiv onClick={onClick}>
          {value ? (
            <Value>
              <span>{date}</span>
              <span>|</span>
              <span>{month}</span>
              <span>|</span>
              <span>{year}</span>
            </Value>
          ) : (
            <Placeholder>
              <span>DD</span>
              <span>|</span>
              <span>MM</span>
              <span>|</span>
              <span>YYYY</span>
            </Placeholder>
          )}
        </FlexDiv>
      </div>
    );
  });

  CustomInput.displayName = "DatePicker";

  return (
    <ReactDatePicker
      ref={innerRef}
      selected={value}
      onChange={onChange}
      minDate={minDate}
      customInput={<CustomInput />}
      withPortal={withPortal}
    />
  );
};

const StyledDatePicker = styled(FlexDiv)`
  cursor: pointer;
  padding: 15px 24px;
  background: #ffffff;
  border-radius: 48px;
  width: 100%;
  justify-content: center;
  gap: 40px;
  span {
    font-family: var(--dm-sans);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #282828;
  }
`;

const Value = styled(StyledDatePicker)``;

const Placeholder = styled(StyledDatePicker)`
  span {
    opacity: 0.4;
  }
`;

export default DatePicker;
